export default __webpack_public_path__ + "static/media/CylindricalArmImg.d5514251.png";